export default "__VITE_ASSET__CUjmKq$N__"